import { render, staticRenderFns } from "./PasswordResetClaim.vue?vue&type=template&id=3b0cf4fa&"
import script from "./PasswordResetClaim.vue?vue&type=script&lang=js&"
export * from "./PasswordResetClaim.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports